import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {AccountSortField as AccountSortFields} from 'src/openapi/admin/models/AccountSortField';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const userConferencesStateSlice = getCachedTableStateSlice<
    AccountSearchCriteria,
    AccountSortField,
    undefined
>('userConferencesState', AccountSortFields.ACCOUNT_NAME);

export const userConferencesStateActions = userConferencesStateSlice.actions;
export const userConferencesStateSelector:
CachedTableStateSelector<AccountSearchCriteria, AccountSortField, undefined> =
    state => state.userPage.tabs.userConferences.state;
